import type { Messages } from '@/i18n/messages/en/index.ts'

/**
 * `brand` em português do Brasil. Declarado, nunca inferido, para que uma falta quebre o
 * `tsc`.
 *
 * ── O que NÃO se traduz aqui ──
 *
 * **Ralph**, **Gi**, **EVT** e **Neoenergia** são nomes próprios e aparecem exatamente como
 * em inglês (ADR-0018, D-17). O que muda é a prosa em volta deles. `productName` nem sequer
 * chega neste arquivo: continua em `profiles.ts`, porque é nome e não frase.
 *
 * ── "governed" ──
 *
 * Não existe adjetivo único em português que faça o trabalho de *governed* aqui — *governado*
 * soa a território ocupado, e *controlado* promete uma coisa diferente (e menor) do que o
 * produto faz. A forma que um produto brasileiro usaria é **"com governança"**, que é
 * exatamente o que a página de Governança já chama de `Governança`. Uma ideia, uma palavra,
 * nas duas línguas.
 *
 * ── "shows its work" ──
 *
 * É o idioma da prova de matemática: mostrar como se chegou ao resultado. Traduzir por
 * *mostra seu trabalho* seria literal e não diria nada; **"como foi feita"** é o que a frase
 * quer dizer, e é o que a trilha da resposta de fato mostra.
 *
 * ── O gênero da Gi ──
 *
 * *assistente* é comum de dois gêneros, então o artigo decide. Gi é lida como nome feminino
 * por qualquer leitor brasileiro, e "o assistente Gi" soaria errado em voz alta. Está no
 * feminino de propósito e em um lugar só, para que uma revisão nativa possa virar tudo numa
 * linha se a Neoenergia disser o contrário (PRD-27 D-21).
 */
export const brand: Messages['brand'] = {
  organisation: 'sua organização',

  profiles: {
    ralph: {
      tagline: 'O assistente com governança para o conhecimento da sua própria organização.',
      description:
        'Ralph Chat — o assistente corporativo com governança. Toda resposta mostra suas fontes, seu custo e como foi feita.'
    },
    evt: {
      tagline: 'O assistente com governança da EVT para o conhecimento que as suas áreas já têm.',
      description:
        'Ralph na EVT — o assistente corporativo com governança. Toda resposta mostra suas fontes, seu custo e como foi feita.'
    },
    neoenergia: {
      tagline: 'Gi é a assistente da Neoenergia para o conhecimento por trás da rede.',
      description:
        'Gi — a assistente da Neoenergia, com governança. Toda resposta mostra suas fontes, seu custo e como foi feita.'
    }
  }
}
